import { DOG_SIZE_KEYS } from '@rover/constants/src/search/search.constants';
import type { HomepageSearchFilters } from '@rover/types/src/HomepageSearchFilters';

// this format matches the original impl in homepage-vue.js/fireSearchAnalyticsEvent
const formatSearchEventDate = (date: Date | null | undefined): string | null => {
  if (!date) return null;
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

const buildSearchEvent = (filters: HomepageSearchFilters) => {
  const dogSize = DOG_SIZE_KEYS.filter((key) => filters[key]).map((key) => key.replace('Dogs', ''));

  return {
    event: 'search-homepage',
    zipCode: filters.location,
    serviceType: filters.serviceTypeSlug,
    dogSize,
    dropOffDate: formatSearchEventDate(filters.dateRange.startDate),
    pickUpDate: formatSearchEventDate(filters.dateRange.endDate),
  };
};

export default buildSearchEvent;
